import merge from "lodash/merge";
import { uuidValid } from "../helpers";
import { ISchema } from "./revalidator";

export const Rules = (rule1: ISchema<{}>, ...rules: Array<ISchema<{}>>): ISchema<{}> => merge(rule1, ...rules);

export const Required = (message?: string): ISchema<{}> =>
	({
		required: true,
		messages: {
			required: message || "Required",
		},
	} as any);

export const Optional = (): ISchema<{}> =>
	({
		required: false,
	} as any);

export const Nullable = (): ISchema<{}> =>
	({
		allowEmpty: true,
	} as any);

export const NotNullable = (message?: string): ISchema<{}> =>
	({
		allowEmpty: false,
		messages: {
			allowEmpty: message || "Required",
		},
	} as any);

export const String = (message?: string): ISchema<{}> => ({
	type: "string",
	messages: {
		type: message || "Not valid",
	},
});

export const Number = (message?: string): ISchema<{}> => ({
	type: "number",
	messages: {
		type: message || "Not valid",
	},
});

export const Boolean = (message?: string): ISchema<{}> => ({
	type: "boolean",
	messages: {
		type: message || "Not valid",
	},
});

export const Accept = (message?: string): ISchema<{}> =>
	({
		enum: [true, "true", "yes"],
		messages: {
			enum: message || "Not valid",
		},
	} as any);

export const NoAccept = (message?: string): ISchema<{}> =>
	({
		enum: [false, "false", "no"],
		messages: {
			enum: message || "Not valid",
		},
	} as any);

export const Date = (message?: string): ISchema<{}> => ({
	type: "string",
	pattern: /(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/,
	messages: {
		type: message || "Not valid",
		pattern: message || "Not valid",
	},
});

export const Length = (length: number, message?: string): ISchema<{}> => ({
	type: "string",
	minLength: length,
	maxLength: length,
	messages: {
		type: message || "Not valid",
		minLength: message || `Should be ${length} symbols`,
		maxLength: message || `Should be ${length} symbols`,
	},
});

export const MinLength = (minLength: number, message?: string): ISchema<{}> => ({
	type: "string",
	minLength,
	messages: {
		type: message || "Not valid",
		minLength: message || `Should be ${minLength} symbols at least`,
	},
});

export const MaxLength = (maxLength: number, message?: string): ISchema<{}> => ({
	type: "string",
	maxLength,
	messages: {
		type: message || "Not valid",
		maxLength: message || `Should be ${maxLength} symbols at maximum`,
	},
});

export const ExclusiveMinimum = (exclusiveMinimum: number, message?: string): ISchema<{}> => ({
	type: "number",
	exclusiveMinimum,
	messages: {
		type: message || "Not valid",
		minLength: message || `Should be greater or ${exclusiveMinimum}`,
	},
});

export const ExclusiveMaximum = (exclusiveMaximum: number, message?: string): ISchema<{}> => ({
	type: "number",
	exclusiveMaximum,
	messages: {
		type: message || "Not valid",
		maxLength: message || `Should be less or ${exclusiveMaximum}`,
	},
});

export const Min = (minimum: number, message?: string): ISchema<{}> => ({
	type: "number",
	minimum,
	messages: {
		type: message || "Not valid",
		minLength: message || `Should be greater or ${minimum}`,
	},
});

export const Max = (maximum: number, message?: string): ISchema<{}> => ({
	type: "number",
	maximum,
	messages: {
		type: message || "Not valid",
		maxLength: message || `Should be less or ${maximum}`,
	},
});

export const Uuid = (message?: string): ISchema<{}> => ({
	type: "string",
	conform: (value: string) => uuidValid(value),
	messages: {
		type: message || "Not valid",
		conform: message || "Not valid UUID",
	},
});

export const Email = (message?: string): ISchema<{}> => ({
	type: "string",
	format: "email",
	messages: {
		type: message || "Not valid",
		format: message || "Not valid email",
	},
});

export const Enum = (values: Array<string> | Array<number> | Array<boolean>, message?: string): ISchema<{}> =>
	({
		enum: values,
		messages: {
			enum: message || "Not valid",
		},
	} as any);

export const Same = (exact: string | number, message?: string): ISchema<{}> => ({
	type: ["string", "number"],
	conform: value => value === exact,
	messages: {
		type: message || "Not valid",
		conform: message || "Not same",
	},
});
